import type { OnboardingProfile } from '@/types/User';

export function getOnboardingRedirectPath(
  onboardingProfile: OnboardingProfile | undefined,
  fallbackPath = '/onboarding/choose'
): string | null {
  if (onboardingProfile?.requiresOnboarding !== true) {
    return null;
  }

  return onboardingProfile.nextStepPath || fallbackPath;
}
